import * as Yup from "yup";
import { KeyValueMap } from "../../../../../../../../redux/slices/appState/models";
import { AddFacilitatorFormKeys } from "./model";

export const addFacilitatorSchema = (commonValidationMessages: KeyValueMap) =>
  Yup.object().shape({
    [AddFacilitatorFormKeys.function]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [AddFacilitatorFormKeys.facilitator]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
  });

export const editFacilitatorFunSchema = (
  commonValidationMessages: KeyValueMap,
  isMandatory: boolean,
) =>
  Yup.object().shape({
    coach: isMandatory
      ? Yup.string().required(commonValidationMessages.requiredValidation)
      : Yup.string(),
  });
